import {
  Popper,
  Paper,
  Typography,
  ClickAwayListener,
  Box,
  Badge,
  IconButton,
  Menu,
  MenuItem,
  Divider,
  Avatar,
  useMediaQuery,
  useTheme,
  CircularProgress,
  Skeleton,
} from "@mui/material";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { EncryptStorage } from "encrypt-storage";
import { motion } from "framer-motion";
import { subscribeMessage } from "Config/natsClient";
import moment from "moment";
import { ROUTES } from "Route/ConstantRoute";
import { useDispatch, useSelector } from "react-redux";
import { fetchDataNotifikasi, resetData } from "slice/notifikasiSlice";

const bellVariants = {
  ring: {
    rotate: [0, 25, -25, 20, -20, 10, -10, 5, -5, 0],
    transition: {
      duration: 1,
      ease: "easeInOut",
      repeat: Infinity,
    },
  },
};

// Komponen ikon dengan animasi
// const AnimatedIcon = styled(NotificationsActiveIcon)(({ theme }) => ({
//   animation: `${ring} 1s ease-in-out infinite`,
// }));

export const Notifikasi = () => {
  moment.locale("id"); // set locale ke Indonesia
  const dispatch = useDispatch();
  const observer = useRef();
  const { items, status, page, hasMore, paginations, notif } = useSelector(
    (state) => state.notifikasi || {}
  );
  // console.log(status, "status");
  // console.log(paginations, "paginations");
  // console.log(notif, "notif");
  const dateNow = moment().format("D MMMM YYYY");
  const navigate = useNavigate();
  const encryptStorage = new EncryptStorage(process.env.REACT_APP_SECRET_KEY);
  const userInfo = encryptStorage.getItem("___info");
  const permission_flag =
    userInfo?.permission_flag != undefined
      ? JSON.parse(userInfo?.permission_flag)
      : {};
  // console.log(userInfo, 'userInfo')

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [isRinging, setIsRinging] = useState(false);
  const [activeNotif, setActiveNotif] = useState(null);
  const [datas, setDatas] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const iconRef = useRef(null);
  const menuOpen = Boolean(anchorEl);

  const handleBellClick = () => {
    setIsRinging(true);
    setOpen(!open);
    dispatch(fetchDataNotifikasi({ page: 0, read: true }));
    // setTimeout(() => setIsRinging(false), 1000);
  };

  const handleClose = () => {
    setOpen(false);
    dispatch(resetData());
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setActiveNotif(null);
    // setDatas([])
    dispatch(resetData());
  };

  const goToReport = (id) => {
    navigate(ROUTES.report.report_detail.replace(":id", id), {
      state: { nama: "maulana" },
    });
    handleClose();
  };

  useEffect(() => {
    // if (!isSubscribed) return;
    const callback = async (data) => {
      console.log("dpo detected");
      dispatch(fetchDataNotifikasi(page));
    };
    // dispatch(fetchDataNotifikasi(page));
    const unsubscribe = subscribeMessage("notifikasiNew", callback);
    // dispatch(setConnected());
    return () => {
      if (typeof unsubscribe === "function") {
        unsubscribe();
        // console.log('masukk')
        // dispatch(setDisconnected());
      }
    };
  }, []);

  useEffect(() => {
    dispatch(fetchDataNotifikasi({ page }));
  }, [dispatch]);

  const lastElementRef = useCallback(
    (node) => {
      if (status === "loading" || !hasMore) return;
      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          dispatch(fetchDataNotifikasi({ page, read: true }));
        }
      });

      if (node) observer.current.observe(node);
    },
    [status, hasMore, dispatch, page]
  );

  return (
    <div>
      <ClickAwayListener onClickAway={handleClose}>
        <Box sx={{ display: "inline-block", cursor: "pointer" }}>
          <Badge badgeContent={notif?.noReadNotif} color="error">
            <motion.div
              ref={iconRef}
              variants={{
                ring: {
                  rotate: [0, 25, -25, 20, -20, 10, -10, 5, -5, 0],
                  transition: {
                    duration: 1,
                    ease: "easeInOut",
                    repeat: Infinity, // loop terus menerus
                    repeatType: "loop",
                  },
                },
              }}
              animate={datas?.length !== 0 ? "ring" : "initial"}
              // animate='ring'
              onClick={handleBellClick}
            >
              <NotificationsActiveIcon color="action" />
            </motion.div>
          </Badge>

          <Popper
            open={open}
            anchorEl={iconRef.current}
            placement={isMobile ? "bottom" : "bottom-end"}
            sx={{
              zIndex: 1300,
              mt: 1,
              width: isMobile ? "90vw" : 400,
              maxWidth: "100%",
            }}
          >
            <Paper elevation={4} sx={{ maxHeight: "70vh", overflow: "hidden" }}>
              {/* Header */}
              <Box
                sx={{
                  position: "sticky",
                  top: 0,
                  zIndex: 1,
                  bgcolor: "background.paper",
                  p: 2,
                  borderBottom: "1px solid",
                  borderColor: "divider",
                }}
              >
                <div className="flex text-center gap-x-2">
                  <Typography variant="h6" fontWeight="bold">
                    Notifikasi DPO
                  </Typography>
                  <Typography
                    variant="h6"
                    fontWeight="bold"
                    color="warning"
                    // sx={{ mb: 1 }}
                  >
                    {dateNow}
                  </Typography>
                </div>
              </Box>

              {/* Content */}
              <Box
                sx={{
                  overflowY: "auto",
                  maxHeight: "calc(70vh - 57px)",
                }}
              >
                {/* Loading State */}
                {isLoading && (
                  <Box sx={{ display: "flex", justifyContent: "center", p: 4 }}>
                    <CircularProgress />
                  </Box>
                )}

                {/* Empty State */}
                {!isLoading &&
                  (!paginations || paginations?.totalItems === 0) && (
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        p: 4,
                        textAlign: "center",
                      }}
                    >
                      <MailOutlineIcon
                        sx={{ fontSize: 48, color: "text.disabled", mb: 2 }}
                      />
                      <Typography variant="body1" color="text.secondary">
                        Tidak ada notifikasi
                      </Typography>
                    </Box>
                  )}

                {/* Data List */}
                {!isLoading &&
                  items &&
                  items?.length > 0 &&
                  items?.map((notif, index) => (
                    <Box
                      key={notif.id}
                      ref={index === items.length - 1 ? lastElementRef : null}
                      sx={{
                        p: 2,
                        borderBottom: "1px solid",
                        borderColor: "divider",
                        cursor: "pointer",
                        "&:hover": {
                          backgroundColor: "#ffebee",
                          // backgroundColor: "action.hover",
                        },
                      }}
                      onClick={() => goToReport(notif?.uuid_report)}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyItems: "center",
                          gap: 1.5,
                        }}
                      >
                        <Avatar
                          src={notif?.person_image_path}
                          // src={displayBinaryImage(notif?.person_image)}
                          sx={{ width: 40, height: 40 }}
                        />
                        <Box sx={{ flex: 1 }}>
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <Typography variant="subtitle1" fontWeight="bold">
                              {index + 1}. {notif?.person_name}
                            </Typography>
                            {/* <IconButton
                              size="small"
                              onClick={(e) => handleMenuClick(e, index)}
                              sx={{ ml: 1 }}
                            >
                              <MoreVertIcon fontSize="small" />
                            </IconButton> */}
                          </Box>
                          <Typography
                            variant="subtitle2"
                            fontWeight="bold"
                            color="text.secondary"
                            sx={{ mb: 1 }}
                          >
                            {notif?.camera_name}
                          </Typography>
                          {/* Content */}
                          {notif?.operation_name && (
                            <Typography variant="body2" sx={{ mt: 1 }}>
                              {notif?.operation_name}
                            </Typography>
                          )}

                          {/* Time */}
                          {notif?.date_created && (
                            <Typography
                              variant="caption"
                              sx={{
                                display: "block",
                                mt: 1,
                                color: "text.secondary",
                                textAlign: "left",
                              }}
                            >
                              {moment(notif?.date_created).fromNow()}
                              {/* {notif?.date_created} */}
                            </Typography>
                          )}
                        </Box>
                      </Box>
                    </Box>
                  ))}
                {status === "loading" && (
                  <div>
                    <Box
                      sx={{
                        p: 2,
                        borderBottom: "1px solid",
                        borderColor: "divider",
                      }}
                    >
                      <Box sx={{ display: "flex", justifyContent: "end" }}>
                        <Skeleton
                          variant="rectangular"
                          width="85%"
                          height={50}
                          sx={{ mb: 2 }}
                        />{" "}
                      </Box>
                      {/* Placeholder for the content area */}
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <Skeleton
                          variant="circular"
                          width={40}
                          height={40}
                          sx={{ marginRight: 2 }}
                        />{" "}
                        {/* Avatar skeleton */}
                        <Box sx={{ flex: 1 }}>
                          <Skeleton
                            variant="text"
                            width="60%"
                            height={20}
                            sx={{ mb: 1 }}
                          />{" "}
                          {/* Name placeholder */}
                          <Skeleton
                            variant="text"
                            width="40%"
                            height={15}
                            sx={{ mb: 1 }}
                          />{" "}
                          {/* Camera name placeholder */}
                          <Skeleton
                            variant="text"
                            width="80%"
                            height={15}
                            sx={{ mb: 1 }}
                          />{" "}
                          {/* Operation name placeholder */}
                          <Skeleton
                            variant="text"
                            width="40%"
                            height={10}
                            sx={{ mb: 1 }}
                          />{" "}
                          {/* Time placeholder */}
                        </Box>
                      </Box>
                    </Box>
                  </div>
                )}
                <div></div>
              </Box>
            </Paper>
          </Popper>
        </Box>
      </ClickAwayListener>

      {/* Menu untuk titik tiga */}
      <Menu
        anchorEl={anchorEl}
        open={menuOpen}
        onClose={handleMenuClose}
        onClick={(e) => e.stopPropagation()}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <MenuItem onClick={handleMenuClose}>Tandai sudah dibaca</MenuItem>
        <MenuItem onClick={handleMenuClose}>Hapus notifikasi</MenuItem>
        <Divider />
        <MenuItem onClick={handleMenuClose}>Pengaturan notifikasi</MenuItem>
      </Menu>
    </div>
  );
};
